module.exports = __webpack_public_path__ + "img/bold.54d33dc3.svg";